
  import React from "react"
  import Component from "/Users/fkn/Sites/Antistatique/epfl-protonav-2/src/layouts/index.js"
  import data from "/Users/fkn/Sites/Antistatique/epfl-protonav-2/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js